<div class="reactivate-subscription-modal">
  <button
    type="button"
    class="button-undecorated reactivate-close-button"
    [attr.aria-label]="translationRoot + '.close' | transloco"
    (click)="closeModal()"
  >
    <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
  </button>

  <h2 class="reactivate-title">{{ translationRoot + '.title' | transloco }}</h2>

  <p class="reactivate-info">{{ translationRoot + '.info' | transloco }}</p>

  <img class="reactivate-artwork" src="assets/icons/reactivate-modal.svg" alt="" />

  <p class="reactivate-price">
    {{ translationRoot + '.price.first' | transloco }}
    <strong>{{ price() }}/{{ billingPeriodKey() | transloco }}</strong>
    {{ translationRoot + '.price.second' | transloco }}
  </p>

  @if (allErrors.length) {
    <div class="generic-errors" role="alert">
      @for (error of allErrors; track $index) {
        <span class="error"><cwo-icon class="icon" [name]="iconNameType.error" />{{ error }}</span>
      }
    </div>
  }

  <div class="reactivate-actions">
    <button
      type="button"
      cwoAsyncButton
      class="button-accent reactivate-confirm-button"
      [subscription]="loadingSubscription"
      [attr.aria-busy]="!!loadingSubscription"
      (click)="reactivateSubscription()"
    >
      {{ translationRoot + '.reactivate' | transloco }}
    </button>

    <button type="button" class="button-accent-secondary reactivate-dismiss-button" (click)="closeModal()">
      {{ translationRoot + '.not_now' | transloco }}
    </button>
  </div>

  @if (nextPaymentDate()) {
    <p class="reactivate-next-payment">
      {{ translationRoot + '.next_payment' | transloco: { date: nextPaymentDate() } }}
    </p>
  }
</div>
